var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 14.1667H11.6667V15.8333H5V14.1667ZM5 10H15V11.6667H5V10ZM5 18.3333H9.16667V20H5V18.3333Z",
    fill: "#1B2559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.1818 2.67857H15.4545V1.78571C15.4545 1.31211 15.263 0.85791 14.922 0.523023C14.581 0.188137 14.1186 0 13.6364 0H6.36364C5.88142 0 5.41896 0.188137 5.07799 0.523023C4.73701 0.85791 4.54545 1.31211 4.54545 1.78571V2.67857H1.81818C1.33597 2.67857 0.873508 2.86671 0.532533 3.20159C0.191558 3.53648 0 3.99068 0 4.46429V23.2143C0 23.6879 0.191558 24.1421 0.532533 24.477C0.873508 24.8119 1.33597 25 1.81818 25H18.1818C18.664 25 19.1265 24.8119 19.4675 24.477C19.8084 24.1421 20 23.6879 20 23.2143V4.46429C20 3.99068 19.8084 3.53648 19.4675 3.20159C19.1265 2.86671 18.664 2.67857 18.1818 2.67857ZM6.36364 1.78571H13.6364V5.35714H6.36364V1.78571ZM18.1818 23.2143H1.81818V4.46429H4.54545V7.14286H15.4545V4.46429H18.1818V23.2143Z",
    fill: "#1B2559"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.9caa74a81e036d6fd12fd02c0d728717.svg";
export { ForwardRef as ReactComponent };